import Vue from 'vue'
import Router from 'vue-router'

import Dashboard from './views/Dashboard/Dashboard'

import AdministrationContainer from './views/Administration/AdministrationContainer'
import NewsList from './views/Administration/News/NewsList'
import EncryptionKeysList from './views/Administration/EncryptionKeys/EncryptionKeysList'
import DownloadsDetails from './views/Administration/Downloads/DownloadsDetails'
import CancerRegisterList from './views/Administration/CancerRegister/CancerRegisterList'
import CancerRegisterDetails from './views/Administration/CancerRegister/CancerRegisterDetails'
import MonitoringUsersList from './views/Administration/Monitoring/MonitoringUsersList'
import MonitoringMailQueueDetails from './views/Administration/Monitoring/MonitoringMailQueueDetails'
import MonitoringMetadataDetails from './views/Administration/Monitoring/MonitoringMetadataDetails'
import InsuranceCompanyList from './views/Administration/InsuranceCompany/InsuranceCompanyList'
import InsuranceCompanyDetails from './views/Administration/InsuranceCompany/InsuranceCompanyDetails'

import AccountDetails from './views/Account/AccountDetails'

import PatientsList from './views/Patients/PatientsList'
import Patient from './views/Patients/Patient'
import Blacklist from './views/Patients/Blacklist'

import Import from './views/Import/Import'

import PhysiciansList from './views/Administration/Physicians/PhysiciansList'
import PhysicianDetails from './views/Administration/Physicians/PhysicianDetails'

import EmployeesList from './views/Administration/Employees/EmployeesList'
import EmployeeDetails from './views/Administration/Employees/EmployeeDetails'

import CompaniesList from './views/Administration/Companies/CompaniesList'
import CompanyDetails from './views/Administration/Companies/CompanyDetails'

import MaintenanceOverview from './views/Administration/Maintenance/MaintenanceOverview'

import Statistics from './views/Statistics/Statistics'
import ReportsList from './views/Reports/ReportsList'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/account/:tabid',
      name: 'AccountDetails',
      component: AccountDetails,
      props: true,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/patients/blacklist/:tabid',
      name: 'Blacklist',
      component: Blacklist,
      props: true,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/patients/:tabid/',
      name: 'PatientsList',
      component: PatientsList,
      props: true,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/import/:tabid',
      name: 'Import',
      component: Import,
      props: true,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/patient/new/:tabid',
      name: 'PatientNew',
      component: Patient,
      props: true,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/patient/details/:tabid/:patientId',
      name: 'PatientDetails',
      component: Patient,
      props: true,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/reports/:tabid',
      name: 'ReportsList',
      component: ReportsList,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/physicians/:tabid',
      name: 'PhysiciansList',
      component: PhysiciansList,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/physicians/details/:tabid/:physicianId',
      name: 'PhysicianDetails',
      component: PhysicianDetails,
      props: true,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/physicians/new/:tabid',
      name: 'PhysicianNew',
      component: PhysicianDetails,
      props: true,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/statistics/:tabid',
      name: 'Statistics',
      component: Statistics,
      props: true,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/downloads/:tabid',
      name: 'DownloadsDetails',
      component: DownloadsDetails,
      props: true,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/administration',
      name: 'AdministrationContainer',
      component: AdministrationContainer,
      props: true,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'news/:tabid',
          name: 'NewsList',
          component: NewsList,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'encryptionKeys/:tabid',
          name: 'EncryptionKeysList',
          component: EncryptionKeysList,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'cancerregister/:tabid',
          name: 'CancerRegisterList',
          component: CancerRegisterList,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'cancerregister/details/:tabid/:registerId',
          name: 'CancerRegisterDetails',
          component: CancerRegisterDetails,
          props: true,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'cancerregister/new/:tabid',
          name: 'CancerRegisterNew',
          component: CancerRegisterDetails,
          props: true,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'companies/:tabid',
          name: 'CompaniesList',
          component: CompaniesList,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'companies/details/:tabid/:companyId',
          name: 'CompanyDetails',
          component: CompanyDetails,
          props: true,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'companies/new/:tabid',
          name: 'CompanyNew',
          component: CompanyDetails,
          props: true,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'maintenance/:tabid',
          name: 'MaintenanceOverview',
          component: MaintenanceOverview,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'employees/:tabid',
          name: 'EmployeesList',
          component: EmployeesList,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'employees/details/:tabid/:employeeId',
          name: 'EmployeeDetails',
          component: EmployeeDetails,
          props: true,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'employees/new/:tabid',
          name: 'EmployeeNew',
          component: EmployeeDetails,
          props: true,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'insuranceCompanies',
          name: 'InsuranceCompanyList',
          component: InsuranceCompanyList,
          props: true,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'insuranceCompanies/new',
          name: 'InsuranceCompanyDetails',
          component: InsuranceCompanyDetails,
          props: true,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: 'monitoring/users',
          name: 'MonitoringUsersList',
          component: MonitoringUsersList,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'monitoring/mailQueue',
          name: 'MonitoringMailQueueDetails',
          component: MonitoringMailQueueDetails,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'monitoring/metadata',
          name: 'MonitoringMetadataDetails',
          component: MonitoringMetadataDetails,
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '*',
      redirect: '/dashboard'
    }
  ]
})

export default router
